import React from 'react';
import {
  Box,
  Button,
  ChakraProvider,
  Container,
  VStack,
  Heading,
  Text,
  extendTheme,
  Image,
  HStack,
  Badge
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#e3f2fd',
      100: '#bbdefb',
      200: '#90caf9',
      300: '#64b5f6',
      400: '#42a5f5',
      500: '#2196F3',
      600: '#1976D2',
      700: '#1565C0',
    },
  },
});

const MainPage = () => {
  const navigate = useNavigate();

  return (
    <ChakraProvider theme={theme}>
      <Box minH="100vh" bg="gray.50" py={20}>
        <Container maxW="container.md" centerContent>
          <VStack spacing={8} align="center">
            {/* Logo */}
            <Box mb={4}>
              <Image 
                src="/logo.svg" 
                alt="Pose Logo" 
                maxH="120px"
                maxW="300px"
              />
            </Box>

            {/* Heading */}
            <VStack spacing={4} textAlign="center">
              <Heading size="2xl" color="black">
                Welcome to Pose
              </Heading>
              <Text fontSize="lg" color="black" maxW="500px">
                Please select your platform and complete both onboarding forms
              </Text>
            </VStack>

            {/* Platform Sections */}
            <VStack spacing={8} w="full" maxW="600px" mt={8}>
              {/* Shopify Section */}
              <Box w="full" p={6} bg="green.50" borderRadius="lg" border="2px solid" borderColor="green.200">
                <VStack spacing={4} align="stretch">
                  <Heading size="lg" color="green.700" textAlign="center">
                    Shopify
                  </Heading>
                  <VStack spacing={3} w="full">
                    <Button
                      size="lg"
                      bg="green.600"
                      color="white"
                      w="full"
                      h="50px"
                      fontSize="md"
                      onClick={() => navigate('/shopify/brand-onboarding')}
                      _hover={{ bg: "green.700", transform: 'translateY(-2px)', boxShadow: 'lg' }}
                      transition="all 0.2s"
                    >
                      Brand Onboarding
                    </Button>
                    <Button
                      size="lg"
                      bg="green.600"
                      color="white"
                      w="full"
                      h="50px"
                      fontSize="md"
                      onClick={() => navigate('/shopify/product-onboarding')}
                      _hover={{ bg: "green.700", transform: 'translateY(-2px)', boxShadow: 'lg' }}
                      transition="all 0.2s"
                    >
                      Product Onboarding
                    </Button>
                  </VStack>
                </VStack>
              </Box>

              {/* Non-Shopify Section */}
              <Box w="full" p={6} bg="blue.50" borderRadius="lg" border="2px solid" borderColor="blue.200">
                <VStack spacing={4} align="stretch">
                  <Heading size="lg" color="blue.700" textAlign="center">
                    Non-Shopify
                  </Heading>
                  <VStack spacing={3} w="full">
                    <Button
                      size="lg"
                      bg="blue.600"
                      color="white"
                      w="full"
                      h="50px"
                      fontSize="md"
                      onClick={() => navigate('/non-shopify/brand-onboarding')}
                      _hover={{ bg: "blue.700", transform: 'translateY(-2px)', boxShadow: 'lg' }}
                      transition="all 0.2s"
                    >
                      Brand Onboarding
                    </Button>
                    <Button
                      size="lg"
                      bg="blue.600"
                      color="white"
                      w="full"
                      h="50px"
                      fontSize="md"
                      onClick={() => navigate('/non-shopify/product-onboarding')}
                      _hover={{ bg: "blue.700", transform: 'translateY(-2px)', boxShadow: 'lg' }}
                      transition="all 0.2s"
                    >
                      Product Onboarding
                    </Button>
                  </VStack>
                </VStack>
              </Box>
            </VStack>
          </VStack>
        </Container>
      </Box>
    </ChakraProvider>
  );
};

export default MainPage;

